import { render, staticRenderFns } from "./Area_presupuesto.vue?vue&type=template&id=0dab3ced"
import script from "./Area_presupuesto.vue?vue&type=script&lang=js"
export * from "./Area_presupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports